import { useQuery, UseQueryFunctionResult } from "@lookiero/messaging-react";
import { viewGameByCustomerId, ViewGameByCustomerIdResult } from "../../../../projection/game/viewGameByCustomerId";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface UseViewGameByCustomerIdFunctionArgs {
  readonly customerId: string;
}

interface UseViewGameByCustomerIdFunction {
  (args: UseViewGameByCustomerIdFunctionArgs): UseQueryFunctionResult<ViewGameByCustomerIdResult>;
}

const useViewGameByCustomerId: UseViewGameByCustomerIdFunction = ({ customerId }) =>
  useQuery({
    query: viewGameByCustomerId({ customerId }),
    contextId: MESSAGING_CONTEXT_ID,
    options: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    },
  });

export { useViewGameByCustomerId };
